import l from "./td-longtail-vue-components174.js";
import o from "./td-longtail-vue-components175.js";
import n from "./td-longtail-vue-components3.js";
/* empty css                              */
import p from "./td-longtail-vue-components98.js";
const s = {
  name: "PaypalButton",
  components: {
    LinkButton: n,
    PaypalIcon: l,
    PaypalLogo: o
  },
  props: {
    label: { type: String, default: "" },
    size: {
      type: String,
      default: "normal",
      validator(a) {
        return ["normal", "large"].includes(a);
      }
    },
    theme: {
      type: String,
      default: "gold",
      validator(a) {
        return ["gold", "white"].includes(a);
      }
    },
    isLabelBefore: { type: Boolean }
  },
  emits: ["click"],
  computed: {
    classes() {
      const a = [];
      return this.theme && a.push(`paypal-button--${this.theme}`), this.isLabelBefore && a.push("paypal-button--label-before"), a;
    }
  }
};
var r = function() {
  var t = this, e = t._self._c;
  return e("LinkButton", { staticClass: "paypal-button", class: t.classes, attrs: { tag: "button", type: "button", large: t.size === "large" }, on: { click: function(c) {
    return t.$emit("click");
  } } }, [e("span", { staticClass: "paypal-button__logo" }, [e("PaypalIcon", { staticClass: "paypal-button__pp paypal-button__pp--short", attrs: { "aria-label": "pp" } }), e("PaypalLogo", { staticClass: "paypal-button__pp paypal-button__pp--long", attrs: { "aria-label": "paypal" } })], 1), t._t("default", function() {
    return [t.label ? e("span", { staticClass: "paypal-button__label" }, [t._v(" " + t._s(t.label) + " ")]) : t._e()];
  })], 2);
}, i = [], u = /* @__PURE__ */ p(
  s,
  r,
  i,
  !1,
  null,
  "c813276d"
);
const d = u.exports;
export {
  d as default
};
